export default __webpack_public_path__ + "static/media/amazonca.32047dbe.png";